import api from "../index";

export const UpgradePlanDiscountListApi = () => api.post("get-upgrade-plan-discounts");
export const AddUpgradePlanDiscountApi = (data, header) => api.post("create-upgrade-plan-discount", data, header);
export const EditUpgradePlanDiscountApi = (data, header) => api.post("update-upgrade-plan-discount", data, header);
export const DeleteUpgradePlanDiscountApi = (data) => api.post("delete-upgrade-plan-discount", data);
